import {useAuth, useLanguage, useModal, useUserAgent} from "../../../hooks/hooks";
import { useDragEvent } from "../../../hooks/useDragEvent";
import { NavigationButton } from "../../common/button/NavigationButton";
import { BannerProps } from "../article1/banner/Banner0";
import { useBannerRef } from "../article1/banner/useBannerRef";
import { BannerVO, LinkOption } from "../../../types/hooks/banner";
import style from "../article1/banner/banner.module.scss";
import {CookieKeys} from "../../../hooks/auth/AuthProvider";
import {ModalType} from "../../../types/common";
import {useCookie} from "../../../hooks/auth/useCookie";

interface Props extends BannerProps {
  isKoreanAndNotAppPage: boolean;
  banners: BannerVO;
}
export function Banners({ wrapperRefCurrent, movePrev, moveNext, isKoreanAndNotAppPage, banners }: Props) {
  const { show, bannerRef } = useBannerRef({ wrapperRefCurrent });
  const { getLanguageStyle } = useLanguage();
  const {getValueFromCookie} = useCookie();
  const {isLoggedIn} = useAuth();
  const { isDesktop} = useUserAgent()
  const {openAlertModal, openModal, openConfirmModal} = useModal();

  const { handleDragStart, handleDragEnd } = useDragEvent({
    moveRight: () => moveNext?.(),
    moveLeft: () => movePrev?.(),
  });

  const handleClickBannerImage = (bannerVO: BannerVO) => {
    if (banners.buttonLink.includes("brain.feel-good")) { // 이부분 임시처리
      if (!isLoggedIn) {
        openAlertModal({
          title: "두뇌유형검사 안내",
          desc: "두뇌유형검사는\n로그인 후 이용 가능합니다.",
          callback: () => openModal(ModalType.LOGIN),
        });
        return;
      }

      const accessToken = getValueFromCookie(CookieKeys.ACCESS_TOKEN);
      const refreshToken = getValueFromCookie(CookieKeys.REFRESH_TOKEN);
      const url = `https://brain.feel-good.io?accessToken=${accessToken}&refreshToken=${refreshToken}`;

      if (!isDesktop) {
        openConfirmModal(
            {
              title: "두뇌유형검사 안내",
              desc: "두뇌유형검사는 \n가로모드만 지원 합니다. \n가로모드 전환 후 확인을 눌러주세요.",
            },
            () => window.open(url)
        );
        return;
      }

      window.open(url);
    } else {
      window.open(banners.buttonLink, banners.linkOption === LinkOption.NEW_TAB ? "_blank" : "_self");
    }
  };

  return (
    <>
      {banners && (
        <div className={`${style.bannerWrapper}`} ref={bannerRef}>
          <div className={style.bannerImage} draggable={true} onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
            <img
              className={`${show ? style.show : style.hide}`}
              style={{cursor:"pointer"}}
              src={banners.image.uri}
              alt={"배너 이미지"}
              draggable={"false"}
              onClick={() => handleClickBannerImage(banners)}
            />
          </div>
          <div className={`${style.textWrapper} ${getLanguageStyle(style)} ${show ? style.show : style.hide}`}>
            <p className={style.slogan}>
              {banners.description1}
              <br />
              <span className={style.strong}>{banners.description2}</span>
            </p>
            <div className={style.downloadTestButtonWrapper}>
              <NavigationButton
                buttonText={
                  // isWithAppPage ? t("section1.download_app") : t("section1.bannerArtistAndStrategist.buttonLabel")
                  banners.buttonDescription
                }
                onClickEvent={() => {
                  handleClickBannerImage(banners);
                  // switch (true) {
                  //     case isWithAppPage:
                  //         navigate(banners.buttonLink);
                  //         break;
                  //     case isKoreanAndNotAppPage:
                  //         navigate(`/purchase-voucher`);
                  //         break;
                  //     default:
                  //         navigate(`/understanding/kpass`);
                  //         break;
                  // }
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
